module.exports = __webpack_public_path__ + "img/4.a46162ca.png";